import React from 'react';
import { ISelectOption, Select } from '../Select';
import { BodyText } from '../Typography';
import { NumberInput } from '../NumberInput';
import { DateTime, Info } from 'luxon';
import styled from 'styled-components';
import { IHasTestData } from '../../test-utilities/IHasTestData';

const MONTHS = Info.months();
const monthOptions = MONTHS.map((item, index) => ({ label: item, value: index + 1 }));

interface ICalendarMonthYearControlsGridProps {
  monthControlType: 'control' | 'label';
  yearControlType: 'control' | 'label';
}
const CalendarMonthYearControlsGrid = styled.div<ICalendarMonthYearControlsGridProps>`
  align-items: center;
  display: grid;
  grid-template-columns: ${(props) => (props.monthControlType === 'control' ? '1.1fr' : 'max-content')} ${(props) =>
      props.yearControlType === 'control' ? '0.9fr' : 'max-content'};
  justify-content: center;
`;
const SelectStyled = styled(Select)`
  .select {
    .select__control--is-focused {
      border-color: ${(props) => props.theme.colors.white};
      box-shadow: none;
    }
    .select__control {
      border-style: none;
      align-items: center;
    }
    border: 0;
  }
`;
const NumberInputStyled = styled(NumberInput)`
  input {
    border: none;
    text-align: left;
    line-height: 1.3px;
    font-size: 15px;
  }
`;

interface ICalendarMonthYearControlsProps extends IHasTestData {
  displayDate: { year: number; month: number };
  monthControlType: 'label' | 'control';
  onCalendarChange: (value: { year: number; month: number }) => void;
  yearControlType: 'label' | 'control';
}

export const CalendarMonthYearControls: React.FC<ICalendarMonthYearControlsProps> = ({
  displayDate,
  monthControlType,
  onCalendarChange,
  yearControlType,
  'data-test-id': dataTestId,
  'data-test-class': dataTestClass,
}) => (
  <CalendarMonthYearControlsGrid monthControlType={monthControlType} yearControlType={yearControlType}>
    {monthControlType === 'control' ? (
      <SelectStyled
        components={{ DropdownIndicator: null }}
        value={monthOptions.find(({ value }) => value === displayDate.month)}
        onChange={(selectMonth: ISelectOption) => {
          onCalendarChange({ ...displayDate, month: selectMonth.value });
        }}
        options={monthOptions}
        data-test-id={dataTestId}
        data-test-class={dataTestClass}
      />
    ) : (
      <BodyText style={{ textAlign: 'center' }}>{MONTHS[displayDate.month - 1]}</BodyText>
    )}
    {yearControlType === 'control' ? (
      <NumberInputStyled
        value={displayDate.year}
        onFocus={(event) => event.target.select()}
        data-test-id={dataTestId}
        data-test-class={dataTestClass}
        onChange={(year: number | null) => {
          const newYear = !!year ? year : DateTime.local().year;
          if (newYear) {
            onCalendarChange({ ...displayDate, year: newYear });
          }
        }}
        format={'####'}
      />
    ) : (
      <BodyText style={{ textAlign: 'center' }}>{displayDate.year}</BodyText>
    )}
  </CalendarMonthYearControlsGrid>
);
